import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import {
  Divider,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from "@material-ui/core";
import { blue } from "@material-ui/core/colors";
import Axios from "axios";
import moment from "moment";
import EditMineralInterest from "./EditMineralInterest";
import ShowNoteComponent from "../../../../ShowNoteComponent";
import DeleteMineralInterest from "./DeleteMineralInterest";
import FileUpload from "../../../../../Components/FileUpload";

const useRowStyles = makeStyles({
    root: {
      "& > *": {
        borderBottom: "unset",
      },
    },
  });
  
export default function MineralInterestRow(props){
  const { row, client_case_id, setInterests } = props;
  const [open, setOpen] = useState(false);
  const classes = useRowStyles();
  const mobile = window.matchMedia("(max-width: 768px)");
  const [isMobile, setIsMobile] = useState(mobile.matches);

  const mobileHandler = () => {
    const windowHandler = () => {
      setIsMobile(mobile.matches);
      if (!isMobile) {
        setOpen(false);
      }
    };

    mobile.addEventListener("change", windowHandler);
    return () => {
      mobile.removeEventListener("change", windowHandler);
    };
  };

  const fetch_interest = () => {
    Axios.get("api/estate/mineral/interest/" + client_case_id)
      .then((res) => {})
      .catch((err) => {
        console.log("error", err);
      });
  };

  useEffect(() => {
    mobileHandler();
    fetch_interest();
  }, []);

  useEffect(() => {}, []);
  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? (
              <KeyboardArrowDownIcon style={{ color: blue }} />
            ) : (
              <KeyboardArrowRightIcon />
            )}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" className="font-weight-normal">
          {row.name ? row.name : 'N/A'}
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.value ? row.value : 0} as of ({moment(row.value_date).format("L")})
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.other_liens ? row.other_liens : 0}
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.client_sp ? row.client_sp : 0}
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.spouse_sp ? row.spouse_sp : 0}
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.net_value ? row.net_value : 0}
        </TableCell>
        <TableCell align="left">
          <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <EditMineralInterest
                row={row}
                setInterests={setInterests}
                client_case_id={client_case_id}
              />
            </span>
          </div>
          <ShowNoteComponent row={row} />
          <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
            <DeleteMineralInterest
              row={row}
              setInterests={setInterests}
              client_case_id={client_case_id}
            />
          </div>
          <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
            <FileUpload row={row} client_case_id={client_case_id} source={'mineral-interest'}/>
          </div>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <div className="shadow mb-3">
                <List>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Name :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal">
                      {row.name}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Type :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal">
                      {row.type}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      State/County:
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal">
                      {row.street_address}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Name of producer/operator :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal">
                      {row.producer}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Current Value :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal">
                      {row.value} as of ({moment(row.value_date).format("L")})
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Liens:
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal">
                      {row.other_liens}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Current Net Equity:
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal">
                      {row.net_value}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Client SP:
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal">
                      {row.client_sp}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Spouse SP :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal">
                      {row.spouse_sp}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Net Value :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal">
                      {row.net_value}
                    </ListItemSecondaryAction>
                  </ListItem>
                </List>
              </div>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}